var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorBoundary',{attrs:{"on-error":_vm.handleError}},[_c('ui-header',{attrs:{"props-data":_vm.headerPropsData}}),_vm._v(" "),_c('main',[_c('nuxt')],1),_vm._v(" "),_c('ui-footer',{attrs:{"props-data":_vm.footerPropsData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }